module.exports = __webpack_public_path__ + "media/images/review/ico-review-badge-a1f48f84131da9634337071a1df67dba.svg";